module.exports = __webpack_public_path__ + "static/media/bancolombia-pe-003-active.7cfa0c48.svg";